module.exports = __webpack_public_path__ + "assets/huiyi.1b5d894d.svg";